import MenuItem from "@Components/Header/MenuItem";
import PartnerWithUsIcon from "@Icons/PartnerWithUsIcon";
import { AppState } from "@Store/index";
import {
  PAGE,
  PROFILE_URL,
  PROFILE_LEADS_URL,
  GROUP_BOOKINGS_URL,
  REFER_URL,
  PARTNER_WITH_AMBER_URL,
  LEADS_LIST,
  PROFILE_SHORTLIST_URL,
} from "constants/configConstants";
import { COMPONENTS_CATEGORY, EVENT_LABEL } from "constants/index";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import { useSelector, shallowEqual } from "react-redux";
import classes from "../../../mobileheader.module.scss";
// import Image from "@Components/Image";
import LogoutIcon from "@Icons/LogoutIcon";
import { logoutRequest } from "@Components/Login/components/helper";
import BookingIcon from "@Icons/BookingIcon";
import useTranslationHook from "hooks/useTranslationHook";
import useWhitelabel from "hooks/useWhitelabel";
import ProfileIcon2 from "@Icons/ProfileIcon2";
import ReferAFriendIcon2 from "@Icons/ReferAFriendIcon2";
import GroupBookingIcon2 from "@Icons/GroupBookingIcon2";
import ListWithUsIcon2 from "@Icons/ListWithUsIcon2";
import ShortlistIcon from "@Icons/ShortlistIcon";
import { LoginToContinueProps } from "../../../types";
import { useMemo, useState } from "react";
import Modal from "@Components/Modal";
import DownloadApp from "../DownloadApp";
import DownloadAppHome from "@Icons/DownloadAppHome";

const LoginToContinue = ({
  hideExtraMenuItems = false,
  isReferralPage = false,
  isAmberPlusHeader = false,
}: LoginToContinueProps) => {
  const {
    PROFILE_CLICKED,
    BOOKINGS_CLICKED,
    GROUP_BOOKINGS_CLICKED,
    REFER_CLICKED,
    PARTNER_WITH_US_CLICKED,
    LIST_WITH_US_CLICKED,
  } = EVENT_LABEL;
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const { isUserLoggedIn, userData, currencyExchangeRates } = useSelector(
    ({ appData }: AppState) => ({
      isUserLoggedIn: appData.isUserLoggedIn,
      userData: appData.userData,
      currencyExchangeRates: appData.currencyExchangeRates,
    }),
    shallowEqual,
  );
  const showLangSelector = true;

  const { isWhitelabel, isDemoSubdomain, partner_uuid } = useWhitelabel();

  const handleEventEmitter = ({ action, label = "", ...rest }: any) => {
    gtagEventEmitter({
      action,
      category: COMPONENTS_CATEGORY.TOP_NAV,
      label: `${PAGE.SEARCH} ${label}`,
      ...rest,
    });
  };

  const handleDownloadAppClick = () => {
    handleEventEmitter({ action: "download_app_clicked" });
    setShowDownloadModal(true);
  };

  const handleLogoutClick = async () => {
    handleEventEmitter({ action: EVENT_LABEL.LOGOUT_CLICKED });
    const { data, error } = await logoutRequest();
    if (data) {
      window.location.reload();
    } else {
      console.log(error);
    }
  };
  const { t } = useTranslationHook();
  const loginToContinueText = t("home.herosection.header.logintocontinue");

  const referBonus = useMemo(() => {
    let referBonusPrice = 50;
    let referCurrency = "GBP";

    if (currencyExchangeRates?.baseCurrency) {
      const exchangeRate = currencyExchangeRates?.rates?.find(
        (rate) => rate.target_currency?.toLowerCase() === referCurrency.toLowerCase(),
      );

      if (exchangeRate?.rate) {
        referBonusPrice = Math.ceil(Number(referBonusPrice) / exchangeRate.rate);
        referCurrency = currencyExchangeRates.baseCurrency.toUpperCase();
      }
    }

    return `${referBonusPrice} ${referCurrency}`;
  }, [currencyExchangeRates?.baseCurrency]);

  return (
    <div className={classes.container}>
      {/* Personal Menu Options */}
      {!isUserLoggedIn && (
        <div className={(classes.highlight, classes.bigHighlight)}>{loginToContinueText}</div>
      )}
      <MenuItem
        label={t("home.herosection.header.profile")}
        icon={<ProfileIcon2 />}
        redirectTo={isDemoSubdomain ? `/profile/?partner_id=${partner_uuid}` : PROFILE_URL}
        clickHandler={() => handleEventEmitter({ action: PROFILE_CLICKED })}
        isDesktop
        addLangPrefixToUrl
      />
      {!isWhitelabel && (
        <MenuItem
          label={t("home.herosection.header.bookings")}
          icon={<BookingIcon />}
          redirectTo={PROFILE_LEADS_URL}
          clickHandler={() => handleEventEmitter({ action: BOOKINGS_CLICKED })}
          isDesktop
          addLangPrefixToUrl
        />
      )}
      {!isWhitelabel && !isReferralPage && !isAmberPlusHeader && showLangSelector && (
        <MenuItem
          label={t("home.herosection.header.shortlist")}
          icon={<ShortlistIcon fill="#000" />}
          rightSection={
            isUserLoggedIn && userData?.data?.inventories_shortlists_ids?.length > 0
              ? `<span style="background-color: #ED3A56; color: white; min-width: 24px; height: 16px; display: inline-flex; align-items: center; justify-content: center; border-radius: 10px; padding: 0.5px 8px;">${userData?.data?.inventories_shortlists_ids?.length}</span>`
              : ""
          }
          redirectTo={
            isDemoSubdomain
              ? `/profile/shortlist/?partner_id=${partner_uuid}`
              : PROFILE_SHORTLIST_URL
          }
          clickHandler={() => handleEventEmitter({ action: "shortlist_clicked" })}
          isDesktop
          addLangPrefixToUrl
        />
      )}
      {!isWhitelabel && !isReferralPage && !isAmberPlusHeader && showLangSelector && (
        <MenuItem
          label={t("home.herosection.header.downloadapp")}
          icon={<DownloadAppHome />}
          clickHandler={handleDownloadAppClick}
          isDesktop
        />
      )}
      {!isWhitelabel && !hideExtraMenuItems && (
        <>
          <div className={classes.divider} />

          {/* Website Menu Options, not needed now */}
          <MenuItem
            label={t("home.herosection.header.groupbooking")}
            icon={<GroupBookingIcon2 />}
            rightSection={t("home.herosection.header.new")}
            redirectTo={GROUP_BOOKINGS_URL}
            clickHandler={() => handleEventEmitter({ action: GROUP_BOOKINGS_CLICKED })}
            isDesktop
          />
          {/* <MenuItem label='Offers' icon={<i className='icon-offers-1' />} /> */}
          {/* Website Menu Options, not needed now */}
          {/* <MenuItem
            label="Group Booking"
            icon={<ReferAFriendIcon2 />}
            rightSection={t("New")}
            redirectTo={GROUP_BOOKINGS_URL}
            clickHandler={() => handleEventEmitter({ action: GROUP_BOOKINGS_CLICKED })}
            isDesktop
          /> */}
          {/* <MenuItem label='Offers' icon={<i className='icon-offers-1' />} /> */}

          <MenuItem
            label={t("home.herosection.header.referafriend")}
            icon={<ReferAFriendIcon2 />}
            rightSection={`${t("home.herosection.header.get")} ${referBonus}`}
            redirectTo={REFER_URL}
            clickHandler={() => handleEventEmitter({ action: REFER_CLICKED })}
            isDesktop
          />
          <MenuItem
            label={t("home.herosection.header.partnerwithus")}
            icon={<PartnerWithUsIcon width={16} height={16} fill="#000" />}
            redirectTo={PARTNER_WITH_AMBER_URL}
            clickHandler={() => handleEventEmitter({ action: PARTNER_WITH_US_CLICKED })}
            isDesktop
          />
          <MenuItem
            label={t("home.herosection.header.listwithus")}
            icon={<ListWithUsIcon2 />}
            redirectTo={LEADS_LIST}
            clickHandler={() => handleEventEmitter({ action: LIST_WITH_US_CLICKED })}
            isDesktop
          />
        </>
      )}

      {isUserLoggedIn && (
        <>
          <div className={classes.divider} />
          <MenuItem
            icon={<LogoutIcon width={16} height={16} fill="#000" />}
            label="home.herosection.header.logout"
            clickHandler={handleLogoutClick}
            isDesktop
          />
        </>
      )}

      {showDownloadModal && (
        <Modal
          hideModal={() => setShowDownloadModal(false)}
          className="downloadAppModal"
          size="fitContent"
          align="center"
        >
          <DownloadApp parentPage={PAGE.HOME} />
        </Modal>
      )}
    </div>
  );
};

export default LoginToContinue;
